import createIcon from '../../createIcon';

/**
 * @component @name KeyboardHide
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkg0QzIuOSAyIDIuMDEgMi45IDIuMDEgNEwyIDE0QzIgMTUuMSAyLjkgMTYgNCAxNkgyMEMyMS4xIDE2IDIyIDE1LjEgMjIgMTRWNEMyMiAyLjkgMjEuMSAyIDIwIDJaTTExIDVIMTNWN0gxMVY1Wk0xMSA4SDEzVjEwSDExVjhaTTggNUgxMFY3SDhWNVpNOCA4SDEwVjEwSDhWOFpNNyAxMEg1VjhIN1YxMFpNNyA3SDVWNUg3VjdaTTE2IDE0SDhWMTJIMTZWMTRaTTE2IDEwSDE0VjhIMTZWMTBaTTE2IDdIMTRWNUgxNlY3Wk0xOSAxMEgxN1Y4SDE5VjEwWk0xOSA3SDE3VjVIMTlWN1pNMTIgMjJMMTYgMThIOEwxMiAyMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const KeyboardHide = createIcon('KeyboardHide', [
  [
    'path',
    {
      d: 'M20 2H4C2.9 2 2.01 2.9 2.01 4L2 14C2 15.1 2.9 16 4 16H20C21.1 16 22 15.1 22 14V4C22 2.9 21.1 2 20 2ZM11 5H13V7H11V5ZM11 8H13V10H11V8ZM8 5H10V7H8V5ZM8 8H10V10H8V8ZM7 10H5V8H7V10ZM7 7H5V5H7V7ZM16 14H8V12H16V14ZM16 10H14V8H16V10ZM16 7H14V5H16V7ZM19 10H17V8H19V10ZM19 7H17V5H19V7ZM12 22L16 18H8L12 22Z',
      key: '1c9nd9',
    },
  ],
]);

export default KeyboardHide;
